import cpuIcon from "../assets/svg-icons/smallBlueCPU.svg";
import ramIcon from "../assets/svg-icons/blueRAM.svg";
import storageIcon from "../assets/svg-icons/smallDisk.svg";

const PricingCard = ({
  category,
  price,
  duration,
  buttonColor,
  buttonText,
  actionType,
  destination,
  onClick,
  dewType,
  cpu,
  ram,
  storage,
}) => {
  return (
    <div className="bg-white rounded-md border border-gray-200 hover:shadow-lg transition-shadow duration-300">
      <div className="p-4 grid gap-3">
        <p className="text-sm text-gray-600">{dewType.replace(/([A-Z])/g, ' $1').trim()}</p>
        <p className="text-lg font-bold text-[#1da1fc]">
          NGN {price}.00 <span className="text-sm font-normal text-black/60">/ {duration}</span>
        </p>

        {/* Hardware specs */}
        <div className="grid gap-1 text-sm text-black">
          <div className="flex items-center gap-2">
            <img src={cpuIcon} alt="cpu" className="w-4 h-4" />
            <span>VCPUs: {cpu}</span>
          </div>
          <div className="flex items-center gap-2">
            <img src={ramIcon} alt="ram" className="w-4 h-4" />
            <span>RAM: {ram}</span>
          </div>
          <div className="flex items-center gap-2">
            <img src={storageIcon} alt="storage" className="w-4 h-4" />
            <span>Storage: {storage}</span>
          </div>
        </div>

        {/* Button */}
        {actionType === "link" ? (
          <a
            href={destination}
            target="rel"
            style={{ backgroundColor: buttonColor }}
            className="block text-white text-xs px-6 py-3 rounded-sm text-center"
          >
            {buttonText}
          </a>
        ) : (
          <div
            onClick={onClick}
            style={{ backgroundColor: buttonColor }}
            className="text-white text-xs px-6 py-3 rounded-sm text-center cursor-pointer"
          >
            {buttonText}
          </div>
        )}
      </div>
    </div>
  );
};

export default PricingCard;

